import { createSlice } from '@reduxjs/toolkit'

const calcOrientation = () => {
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
}

const calcDeviceHeight = () => {
    if (window.innerHeight < 640) {
        return 'height-short'
    } else if (window.innerHeight >= 640 && window.innerHeight < 900) {
        return 'height-medium'
    }
    return 'height-tall'
}

const calcDeviceType = () => {
    if (window.innerWidth < 640) {
        return 'mobile'
    } else if (window.innerWidth >= 640 && window.innerWidth < 768) {
        return 'tablet'
    } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        return 'intermediate'
    } else if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
        return 'laptop'
    } else if (window.innerWidth >= 1280 && window.innerWidth < 1399) {
        return 'desktop'
    } else if (window.innerWidth >= 1400 && window.innerWidth < 1600) {
        return 'large-desktop'
    }
    return 'extra-large-desktop'
}

const INITIAL_STATE = {
    width: window.innerWidth,
    height: window.innerHeight,
    orientation: calcOrientation(),
    deviceType: calcDeviceType(),
    deviceHeight: calcDeviceHeight()

}

const uiSlice = createSlice({
    name: 'ui',
    initialState: INITIAL_STATE,
    reducers: {
        saveWindowSize(state, action) {
            state.width = action.payload.width
            state.height = action.payload.height
            state.deviceType = calcDeviceType()
            state.orientation = calcOrientation()
            state.deviceHeight = calcDeviceHeight()
        }
    }
})

export const { saveWindowSize } = uiSlice.actions
export default uiSlice.reducer
